import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1)
const _hoisted_3 = { class: "menu-item mb-4" }
const _hoisted_4 = { class: "row row-text align-items-center mb-4" }
const _hoisted_5 = { class: "col-9 col-xl-8 col-xxl-6" }
const _hoisted_6 = {
  key: 0,
  class: "row row-submenu-setting mb-4"
}
const _hoisted_7 = { class: "col-9 col-xl-8 col-xxl-6" }
const _hoisted_8 = {
  key: 1,
  class: "row row-link mb-4"
}
const _hoisted_9 = { class: "col-9 col-xl-8 col-xxl-6" }
const _hoisted_10 = { class: "row row-visibility-rule mb-4" }
const _hoisted_11 = { class: "col-12 col-xl-10 col-xxl-8" }
const _hoisted_12 = { class: "d-flex align-items-center mb-4" }
const _hoisted_13 = { class: "fs-4 mb-0" }
const _hoisted_14 = ["data-dp-tooltip"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "help", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "add", -1)
const _hoisted_18 = {
  key: 2,
  class: "row row-submenu mb-4"
}
const _hoisted_19 = { class: "col text-warning fst-italic mb-0" }
const _hoisted_20 = {
  key: 3,
  class: "row row-submenu my-5"
}
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_23 = { class: "fs-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "add", -1)
const _hoisted_25 = { class: "d-inline-block mt-3 pt-4 border-top border-2 border-light" }
const _hoisted_26 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_PageLinkPicker = _resolveComponent("PageLinkPicker")!
  const _component_VisibilityRule = _resolveComponent("VisibilityRule")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenusOverview = _resolveComponent("MenusOverview")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: (_ctx.isSubMenu) ? _ctx.$t('subMenuItem') : _ctx.$t('menuItem'),
        "help-text": _ctx.$t('descriptionMenuItemsDetail'),
        mode: _ctx.mode,
        "back-route": _ctx.isSubMenu ? null : _ctx.goBackRoute,
        "use-router-back": _ctx.isSubMenu,
        mb: 5,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent
      }, {
        buttons: _withCtx(() => [
          (_ctx.menuItemUI.isReady())
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "btn btn-hover icon-link text-danger",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteItem && _ctx.deleteItem(...args)), ["prevent"]))
                }, [
                  _hoisted_2,
                  _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "help-text", "mode", "back-route", "use-router-back", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.menuItemUI.getError(),
        class: "mb-5"
      }, null, 8, ["error"]),
      _createVNode(_component_BaseSpinner, {
        spin: _ctx.menuItemUI.isNotReady()
      }, null, 8, ["spin"]),
      (_ctx.menuItemUI.isReady())
        ? (_openBlock(), _createBlock(_component_dp_form, {
            key: 0,
            as: "form",
            onSubmit: _ctx.submitData,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("article", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_InputText, {
                      label: _ctx.$t('name'),
                      name: "menuItemText",
                      modelValue: _ctx.menuItem.menu_item_text,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menuItem.menu_item_text) = $event)),
                      rules: "required|max:50",
                      errors: errors
                    }, null, 8, ["label", "modelValue", "errors"])
                  ])
                ]),
                (_ctx.mode === _ctx.PageDetailModeEnum.NEW && !_ctx.isSubMenu)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_InputCheckboxBoolean, {
                          modelValue: _ctx.hasSubMenu,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hasSubMenu) = $event)),
                          label: _ctx.$t('hasSubMenu'),
                          name: "hasSubMenu",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hasSubMenu || _ctx.isSubMenu)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_PageLinkPicker, {
                          payload: _ctx.pageLinkPayload,
                          "enable-no-link": false,
                          "enable-select-url": "",
                          errors: errors,
                          onChanged: _ctx.onPageLinkPickerChanged,
                          onChangedText: _ctx.onPageLinkPickerChangedText,
                          onExceptions: _ctx.setExceptions
                        }, null, 8, ["payload", "errors", "onChanged", "onChangedText", "onExceptions"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("article", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("header", _hoisted_12, [
                      _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t('visibilityRule')), 1),
                      _createElementVNode("span", {
                        "data-dp-tooltip": _ctx.$t('descriptionVisibilityRule'),
                        "data-dp-position": "top",
                        class: "d-flex lh-1 cu-p ms-2"
                      }, _hoisted_16, 8, _hoisted_14)
                    ]),
                    (!_ctx.hasVisibilityRule)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-icon btn-secondary",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addVisibilityRule && _ctx.addVisibilityRule(...args)))
                        }, [
                          _hoisted_17,
                          _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.hasVisibilityRule)
                      ? (_openBlock(), _createBlock(_component_VisibilityRule, {
                          key: 1,
                          payload: _ctx.menuItem.visibility_rule,
                          errors: errors,
                          onChanged: _ctx.onVisibilityRuleChanged,
                          onDelete: _ctx.deleteVisibilityRule,
                          onError: _ctx.setExceptions
                        }, null, 8, ["payload", "errors", "onChanged", "onDelete", "onError"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.mode === _ctx.PageDetailModeEnum.NEW && _ctx.hasSubMenu)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('saveMenuBeforeManagingSubMenu')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mode === _ctx.PageDetailModeEnum.EDIT && _ctx.hasSubMenu)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("header", _hoisted_22, [
                          _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.$t('subMenu')), 1),
                          _createVNode(_component_router_link, {
                            to: {name: 'new-sub-menu-item', params: {menu_id: _ctx.menuItem.submenu_id}},
                            class: "btn btn-icon btn-secondary mt-1"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _createVNode(_component_MenusOverview, {
                          "menu-id": _ctx.menuItem.submenu_id,
                          "menu-items": _ctx.subMenuItems,
                          "menu-ui": _ctx.menuItemUI,
                          bus: _ctx.bus,
                          "slot-code": _ctx.slotCode,
                          "is-sub-menu": ""
                        }, null, 8, ["menu-id", "menu-items", "menu-ui", "bus", "slot-code"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("section", _hoisted_25, [
                _createVNode(_component_InputSelect, {
                  label: _ctx.$t('status'),
                  name: "status",
                  selectText: _ctx.$t('selectText'),
                  modelValue: _ctx.menuItem.status_code,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.menuItem.status_code) = $event)),
                  options: _ctx.statusOptions,
                  errors: errors
                }, null, 8, ["label", "selectText", "modelValue", "options", "errors"]),
                _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.$t('save')), 1)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}